import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const HeartEmoji = (props: IIconProps) => (
  <BaseIcon width="28" height="24" viewBox="0 0 28 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="m14.014 22.359-.629-.559-.279-.279c-4.42-4.094-7.281-6.932-8.584-8.514C2.661 10.68 1.73 8.54 1.73 6.586c0-1.629.559-3.001 1.675-4.118C4.522 1.352 5.871.793 7.453.793c1.954 0 3.583.768 4.886 2.303l1.675 2.024 1.675-2.024C16.99 1.561 18.619.793 20.574.793c1.582 0 2.931.559 4.048 1.675 1.116 1.117 1.675 2.49 1.675 4.118 0 1.954-.93 4.094-2.792 6.42-1.303 1.583-4.164 4.42-8.584 8.515l-.28.28-.627.558z"
        fill={EColors.MEDIUM_GREY}
        stroke={EColors.WHITE}
        strokeWidth="1.527"
        fillRule="evenodd"
      />
    </g>
  </BaseIcon>
)

export default HeartEmoji
